var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cal-anual"
  }, [_c('div', {
    staticClass: "cal-anual__header"
  }, [_c('div', {
    staticClass: "cal-anual__title"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-calendar-multiselect")]), _vm._v(" Calendário de Formações ")], 1), _c('div', {
    staticClass: "cal-anual__center"
  }, [_c('v-select', {
    staticClass: "cal-anual__select",
    attrs: {
      "items": _vm.anosDisponiveis,
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Ano"
    },
    model: {
      value: _vm.anoInterno,
      callback: function ($$v) {
        _vm.anoInterno = $$v;
      },
      expression: "anoInterno"
    }
  })], 1), _c('div', {
    staticClass: "cal-anual__spacer"
  })]), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(12, function (m) {
    return _c('v-col', {
      key: m,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "month-card",
      attrs: {
        "elevation": 0
      }
    }, [_c('div', {
      staticClass: "month-card__header",
      class: {
        'month-card__header--disabled': !_vm.mesClicavel(m),
        'month-card__header--current': _vm.isMesAtual(m)
      },
      attrs: {
        "role": "button",
        "aria-disabled": !_vm.mesClicavel(m),
        "aria-label": `Abrir ${_vm.nomeMes(m)} de ${_vm.anoInterno}`
      },
      on: {
        "click": function ($event) {
          return _vm.onClickMes(m);
        }
      }
    }, [_c('div', {
      staticClass: "month-card__title"
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-calendar-month")]), _c('span', [_vm._v(_vm._s(_vm.nomeMes(m)))]), _vm.isMesAtual(m) ? _c('span', {
      staticClass: "current-chip",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("ATUAL")]) : _vm._e()], 1)]), _c('v-divider', {
      staticClass: "month-card__divider"
    }), _c('v-calendar', {
      staticClass: "month-card__calendar",
      attrs: {
        "value": `${_vm.anoInterno}-${_vm.pad(m)}-01`,
        "type": "month",
        "events": _vm.eventosNormalizados,
        "locale": "pt-BR",
        "weekdays": [1, 2, 3, 4, 5, 6, 0],
        "short-weekdays": true,
        "show-adjacent-months": false,
        "hide-header": false
      },
      scopedSlots: _vm._u([{
        key: "day",
        fn: function (slot) {
          return [_c('div', {
            staticClass: "day-cell no-pointer",
            class: _vm.dayClasses(slot)
          }, [_c('div', {
            staticClass: "paint",
            style: _vm.getDayStyle(slot)
          }), _c('span', {
            staticClass: "day-num"
          }, [_vm._v(_vm._s(_vm.getDayNumber(slot)))])])];
        }
      }, {
        key: "day-label",
        fn: function (_ref) {
          var day = _ref.day;
          return [_c('span', {
            staticClass: "day-num"
          }, [_vm._v(_vm._s(day.day))])];
        }
      }], null, true)
    })], 1)], 1);
  }), 1), _c('div', {
    staticClass: "legend-global"
  }, [_c('div', {
    staticClass: "legend-global__item"
  }, [_c('span', {
    staticClass: "legend-global__dot",
    style: {
      background: _vm.palette.SEE
    }
  }), _vm._v(" Formação SEE ")]), _c('div', {
    staticClass: "legend-global__item"
  }, [_c('span', {
    staticClass: "legend-global__dot",
    style: {
      background: _vm.palette.Escola
    }
  }), _vm._v(" Formação Escola ")]), _c('div', {
    staticClass: "legend-global__item"
  }, [_c('span', {
    staticClass: "legend-global__dot",
    style: {
      background: _vm.palette.GRE
    }
  }), _vm._v(" Formação GRE ")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }